import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import JBImage from 'components/essentials/JBImage';
import getSubcategories from './getSubcategories';
import ShopPageList from './ShopPageList';
const ShopPageCategoryPanel = t0 => {
  const $ = _c(17);
  const {
    className: t1,
    customPanelContent,
    image,
    inspirationPath,
    name,
    path,
    subcategories: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t3;
  if ($[0] !== name || $[1] !== t2) {
    t3 = t2 === undefined ? getSubcategories(name) : t2;
    $[0] = name;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const subcategories = t3;
  const t4 = `overflow-hidden md:border-[1px] md:border-gray-light6 md:rounded-lg ${className}`;
  let t5;
  if ($[3] !== image || $[4] !== name || $[5] !== path) {
    t5 = image && <Link to={path}><JBImage className="w-full max-[767px]:hidden" src={image} width={500} alt={name} /></Link>;
    $[3] = image;
    $[4] = name;
    $[5] = path;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== customPanelContent || $[8] !== inspirationPath || $[9] !== name || $[10] !== path || $[11] !== subcategories) {
    t6 = customPanelContent || <ShopPageList {...{
      name,
      path,
      subcategories,
      inspirationPath
    }} />;
    $[7] = customPanelContent;
    $[8] = inspirationPath;
    $[9] = name;
    $[10] = path;
    $[11] = subcategories;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
ShopPageCategoryPanel.propTypes = {
  className: PropTypes.string,
  customPanelContent: PropTypes.string,
  image: PropTypes.string,
  inspirationPath: PropTypes.string,
  name: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  subcategories: PropTypes.array
};
export default withRouter(ShopPageCategoryPanel);